import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'messageModal',
    templateUrl: './message-modal.component.html',
    styles: [
        `
            p {
                white-space: pre-line;
                font-size: 1rem;
            }

            .has-error {
                padding: 4px 0;
            }
        `,
    ],
    standalone: false,
})
export class MessageModalComponent implements OnInit {
    constructor(
        public bsModalRef: BsModalRef,
        private readonly _renderer: Renderer2,
        private readonly _elRef: ElementRef,
    ) {}

    result: string = 'Cancel'; // Initialized to Cancel in case user closes modal with outside click

    title: string;

    subtitle: string;

    message: string;

    messageList: string[] = [];

    footerMessage: string;

    hasOK: boolean;
    hasYes: boolean;
    hasNo: boolean;
    hasCancel: boolean;
    hasContinue: boolean;

    isErrorState: boolean;
    hasWarningIcon: boolean;
    hasBackdropClick: boolean;

    ngOnInit(): void {
        // Annoyingly ngx-bootstrap doesn't provide the windowClass property like we used to have
        // So we need to set the modal-on-top class ourselves to ensure this modal appears above others
        const parent = this._elRef.nativeElement.closest('modal-container');
        if (parent) {
            this._renderer.addClass(parent, 'modal-on-top');
        }
    }

    save(): void {
        if (this.hasOK || this.hasContinue) {
            this.result = 'OK';
        } else if (this.hasYes) {
            this.result = 'Yes';
        }
        this.bsModalRef.hide();
    }

    no(): void {
        this.result = 'No';
        this.bsModalRef.hide();
    }

    dismiss(): void {
        this.result = 'Cancel';
        this.bsModalRef.hide();
    }

    cancel(): void {
        if (this.hasCancel) {
            this.result = 'Cancel';
        } else if (this.hasNo) {
            this.result = 'No';
        }
        this.bsModalRef.hide();
    }
}
